import { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Scrollbar, EffectFade } from "swiper";
import "../../css/inner-page/sectionSmsTips.scss";
import "swiper/css/effect-fade";
import { ReactComponent as Loyalty } from "../imgComponents/loyalty.svg";
import { ReactComponent as Smsbump } from "../imgComponents/smsbump.svg";
import { useLocation } from "react-router-dom";

export default function Section(props) {
  const location = useLocation();

  useEffect(() => {
    document.querySelectorAll(".swiper-pagination-custom-bullet").forEach((el, index) => {
      el.addEventListener("click", () => {
        const title = el.querySelector(".tip-name").innerText;
        const tipNo = el.querySelector(".tip-title").innerText;
        handleTipsClick(title, tipNo);
      });
    });
  }, []);

  const handleTipsClick = (title, tipNo) => {
    if (typeof window.redcross !== "undefined") {
      const obj = {
        btnText: title,
        btnContext: "",
        btnName: tipNo,
        btnLocation: `BFCM SMS tips`,
      };
      window.redcross.track("Button Clicked", obj);
    }
  };

  return (
    <section id="sms-tips">
      <div className="sms-tips-wrap">
        <h2 dangerouslySetInnerHTML={{ __html: props.title }}></h2>
        <div className="tip-swiper-wrapper">
          {location.pathname === "/during" && <Smsbump data-aos="fade" className="sticker" />}
          {location.pathname === "/after" && <Loyalty data-aos="fade" className="sticker" />}
          <div className="swiper-pagination pagination-top"></div>
          <Swiper
            modules={[Pagination, Scrollbar, EffectFade]}
            spaceBetween={70}
            slidesPerView={1}
            effect="fade"
            grabCursor={true}
            scrollbar={{ draggable: true }}
            pagination={{
              clickable: true,
              bulletClass: `swiper-pagination-custom-bullet`,
              el: ".swiper-pagination.pagination-top",
              renderBullet: (index, className) => {
                return (
                  "<div class= " +
                  className +
                  "><span class='tip-title'>TIP #" +
                  (index + 1) +
                  "</span><span class='tip-name'>" +
                  props.tips[index].name +
                  "</span></div>"
                );
              },
            }}
          >
            {props.tips.map((item, index) => {
              return (
                <SwiperSlide key={index}>
                  <div className="slide-content">
                    <h3>{item.title}</h3>
                    <p className="font-regular">{item.content}</p>
                  </div>
                  <img data-aos="fade-up" src={item.image_group["1x"]} alt={item.image_group.alt} />
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
      <div
        className="tips-bg"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/outline-tips.svg)`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "auto 100%",
        }}
      ></div>
    </section>
  );
}
